import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'm-sidebar-menu-header',
  template: `
    <span>{{ mHeaderTitle }}</span>
    <div class="m-sidebar-menu-header-extra">
      <ng-container *ngIf="mShowIcon">
        <i nz-icon nzType="plus-square" class="m-sidebar-menu-header-plus" nzTheme="outline" (click)="mOpenChange.emit()"></i>
        <i nz-icon nzType="minus-square" class="m-sidebar-menu-header-minus" nzTheme="outline" (click)="mCloseChange.emit()"></i>
      </ng-container>
    </div>
  `,
  host: {
    class: 'm-sidebar-menu-header'
  }
})
export class MSidebarMenuHeaderComponent {
  @Input() mHeaderTitle: string = '';
  @Input() mShowIcon: boolean = true;

  @Output() readonly mOpenChange = new EventEmitter<void>();
  @Output() readonly mCloseChange = new EventEmitter<void>();
}
